import 'css-chunksrc/client/common/projectPortfoliosList/styles.scss';export default {
  "projectPortfoliosList": "_projectPortfoliosList_1wv5i_1",
  "item": "_item_1wv5i_10",
  "icon": "_icon_1wv5i_14",
  "input": "_input_1wv5i_19",
  "list": "_list_1wv5i_24"
};